

const getColor = async () => {
  // @ts-ignore
  return (await (await (await fetch('/color.json')).json()));
};

export { getColor };
